const matchMedia = {
  XS_MAX: 767,
  SM_MIN: 768,
  SM_MAX: 991,
  MD_MIN: 992,
  MD_MAX: 1199,
  LG_MIN: 1200,
  LG_MAX: 1599,
  XL_MIN: 1600,
  XL_MAX: 3840, // 4k
};

export default matchMedia;
